<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="push-title">
      说明:<h5>1、操作步骤:选择日期,查询日期所在月份的出勤人员,然后点击相应人员姓名则展示对应人员出勤明细。2、修改方式:编辑后回车。3、默认查询当月。4、Excel导入一次性完成人员模板确认和最终结果计算</h5>
      <br />
      <h5 class="red">2022-05-25追加:因误操作导致计算模板删除,可以通过 按钮 计算并审核出勤结果 按钮再次计算打卡结果</h5>
    </div>
    <div class="content_edit" style="display: inline-flex;">
      <div class="content_edit_item">
        <span class="red">{{dep_name}}</span><span>部门&nbsp;&nbsp;{{dep_user}}&nbsp;&nbsp;</span>

      </div>
      <div class="content_edit_item">
        <label>查询日期:</label>
        <el-date-picker style="width: 140px;" v-model="select_day" type="date" value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>

      </div>
      <div class="content_edit_item">
        <label>查询姓名:</label>
        <input type="text" v-model="user_name" style="width: 120px;" />

      </div>
      <div class="my_btn">
        <button @click="fun_load_user()">查询人员</button>
        <button @click="fun_update_user('_end')">计算并审核出勤结果</button>
        <button @click="fun_Excel_up()">Excel导入考勤结果</button>
      </div>
    </div>
    <div id="third_pass" class="third_pass">
      <div class="third-left">
        <table class="dataintable">
          <thead>
            <tr class="tab_header">
              <th> 序号</th>
              <th class="short0">部门</th>
              <th class="short0">用户</th>
              <th class="short0">考勤</th>
            </tr>
          </thead>
          <tbody class="tab_body">
            <tr :id="'user_'+item.row_num" v-for="(item, index) in list_user" :key="index" @click="fun_sel_user(item)">
              <td class="cen">{{ item.row_num }}</td>
              <td class="short0 cen">{{ item.d_name }}</td>
              <td class="short0 cen">{{ item.u_name }}</td>
              <td class="short0 cen">{{ item.is_flag}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="third-right">
        <div class="second-title">
          <span :style="{width:item_width+'px'}">星期一</span>
          <span :style="{width:item_width+'px'}">星期二</span>
          <span :style="{width:item_width+'px'}">星期三</span>
          <span :style="{width:item_width+'px'}">星期四</span>
          <span :style="{width:item_width+'px'}">星期五</span>
          <span :style="{width:item_width+'px'}">星期六</span>
          <span :style="{width:item_width+'px'}">星期日</span>
        </div>
        <div class="second-row" v-for="(item,index) in list_dep_user_all" :key="index">
          <span :id="'DU_'+d.id" class="scond-item" :class="{iserr:d.is_err}" :style="{width:item_width+'px'}"
            v-for="(d,id) in item" :key="id" @click="fun_sel_dep_user_today(d)"
            @dblclick="fun_sel_dep_user_day_toedit(d)">
            <div class="second-item-row" v-show="!d.fixed">
              <span class="record"> {{d.work_date}}</span>&nbsp; <span class="record">{{d.work_result}}</span>
            </div>
            <div class="second-item-row" v-show="!d.fixed">
              <span class="record"> {{d.result_flag}}</span>
            </div>
            <div class="second-item-row" v-show="d.note!=''">
              <span class="record"> {{d.note}}</span>
            </div>
          </span>

        </div>
      </div>
    </div>

    <!-- 弹出 部门人员 单号 start -->
    <div class="top_sheetno" id="pre_detail_data" v-show="show_dep_user_day">
      <span class="top_sheetno_close">
        <img src="../../assets/image/schu.png" @click="closeshow" />
      </span>
      <div class="content_edit ">
        <span class="red">{{dep_name}}</span><span>部门&nbsp;{{dep_user}}&nbsp;&nbsp;&nbsp;选择日期:<h5>{{select_day}}</h5>
        </span>

      </div>
      <div class="content_edit content-tan">
        <div class="tan-row">
          <label>上班时间:</label><span>{{select_dep_user_day.m_up_time}}</span>
        </div>
        <div class="tan-row">
          <label>上班打卡:</label><span class="right">{{select_dep_user_day.u_up_time}}</span>
          <label>{{select_dep_user_day.u_up_flag}}:</label><span
            class="right">{{select_dep_user_day.u_up_minu}}分钟</span>
        </div>
        <div class="tan-row">
          <span>{{select_dep_user_day.u_up_note}}</span>
        </div>
		<div class="tan-row" style="margin-bottom: 10px;">
		  <label>备注:</label><span>{{select_dep_user_day.up_note}}</span>
		</div>
		
        <div class="tan-row">
          <label>下班时间:</label><span>{{select_dep_user_day.a_down_time}}</span>
        </div>
        <div class="tan-row">
          <label>下班打卡:</label><span>{{select_dep_user_day.u2_down_time}}</span>
          <label>{{select_dep_user_day.u2_down_flag}}:</label><span>{{select_dep_user_day.u2_down_minu}}分钟</span>
        </div>
        <div class="tan-row">
          <span>{{select_dep_user_day.u2_down_note}}</span>
        </div>
		<div class="tan-row" style="margin-bottom: 10px;">
		  <label>备注:</label><span>{{select_dep_user_day.down_note}}</span>
		</div>
		
        <div class="tan-row" v-show="select_dep_user_day.f_up">
          <span class="my-file red" @click="fun_look_file">点我查看附件</span>
        </div>
        <div class="tan-row">
          <label>默认出勤:</label>
          <input class="right short" type="text" v-model="select_dep_user_day.work_result" />
          <pre-sel-one class="short" @selectFunc="fun_list_sel($event,'work')" v-bind:searchList="list_rec_class"
            :selectValue="sel_rec_class" />
        </div>
		<div class="tan-row">		
		  <label>考勤状态:</label>
		  <input class="right short" type="text" v-model="select_dep_user_day.result_flag" />
		  <pre-sel-one class="short" @selectFunc="fun_list_sel($event,'result')" v-bind:searchList="list_rec_class"
		    :selectValue="sel_rec_class" />
		</div>
        <div class="tan-row">
          <label>备注:</label>
          <input class="right " type="text" v-model="select_dep_user_day.note"
            @keyup.enter="fun_update_user('_pass')" />
        </div>
        <div class="tan-row">
          <label>打卡状态:</label>
          <el-radio v-model="select_dep_user_day.sel_radio" label="1">正常</el-radio>
          <el-radio v-model="select_dep_user_day.sel_radio" label="2">缺卡</el-radio>
        </div>
        <div class="content_btn_item">
          <button class="pre_btn_ok" @click="fun_update_user('_pass')">保存</button>
        </div>


      </div>
    </div>
    <!-- 弹出 部门人员 单号  end -->


    <!-- 弹出待办业务单号 start -->
    <div class="top_sheetfile" v-show="show_file">
      <span class="top_sheetfile_close">
        <img src="../../assets/image/shan1.png" @click="closeshowfile" />
      </span>
      <div class="content_edit ">
        <h3 class="red">考勤附件</h3>
      </div>
      <div class="content_edit ">
        <div class="pre_tab ">

          <table class="dataintable">
            <thead>
              <tr class="tab_header">
                <th>序号</th>
                <th class="short0">查看</th>
                <th class="long1">上传时间</th>
              </tr>
            </thead>
            <tbody class="tab_body">
              <tr :id="'user_'+item.row_num" v-for="(item, index) in list_file" :key="index"
                @click="fun_sel_user(item)">
                <td>{{ item.row_num }}</td>
                <td class="short0 cen"><a :href="item.url" target="_blank">预览</a></td>
                <td class="long1 cen">{{ item.sys_date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 弹出待办业务单号 end -->

    <!-- 通用导入excel -->
    <per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm_th" :api_url="'exp_record_end'"
      :api_action="'record_end'" :api_method="'longlong'" />
  </div>
</template>

<script>
  import api from '@/utils/type.js'
  import {
    GetShort,
    ChangeSpecial,
    BackSpecial
  } from '@/utils/localstore.js';
  import {
    Method_EasySelect,
    Method_Common
  } from '@/utils/loadhttpdata.js';

  import {
    daysFormMonth
  } from '@/utils/method.js'

  export default {
    components: {
      'pre-sel-one': () => import("../per_old/pre_select_one.vue"),
      'per-excelup': () => import("../per_old/pre_excel_up_new.vue")
    },
    data() {
      return {
        element_loading: false,

        select_day: '',
        dep_name: '',
        user_id: "",
        user_select: '',
        list_user: [],
        list_second: [],

        // 时间组件
        btn_clear: false,
        btn_read: true,

        // 弹窗组件
        list_rec_class: [],
        sel_rec_class: {},

        dep_user: '',
        dep_user_id: 0,
        sheet_no: '',
        list_dep_user_all: [],
        select_user_day: '',
        select_dep_user_day: {},
        show_dep_user_day: false,

        item_width: 0,

        show_file: false,
        list_file: [],

        // Excel上传
        parm_th: [],

        user_name: "",
        sel_c_id: 0,
        sel_w_id: 0


      };
    },
    created: function() {

      this.chang_style();
      this.fun_load_class();
      this.fun_load_user();
    },
    mounted: function() {
      const that = this;
      // 滚动事件 scroll
      // 变形事件 resize
      window.addEventListener('scroll', function() {
        that.chang_style(); //fixed 行相对位置修正
      }, false);
      // 这里只是操作dom
      window.addEventListener('resize', function() {
        that.chang_style(); //fixed 行相对位置修正
      }, false);
    },
    methods: {
      chang_style: function(t) {
        var that = this;
        this.$nextTick(function() {
          // var screenWidth = $(window).width();
          // var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
          // var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
          var row_width = 0;

          row_width = $('#third_pass').width();
          that.item_width = (row_width - 36 - 356) / 7;

          // console.log('行宽=' + row_width);

        });
      },
      closeshow: function() {
        this.show_dep_user_day = false;
      },
      closeshowfile: function() {
        this.show_file = false;
      },
      fun_load_class: function() {

        this.element_loading = true;
        this.list_rec_class = [];
        this.$post(
          api.http_method, Method_EasySelect('data_exp_rec_class', '1')
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;
            this.list_rec_class = res.data.data;

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });

          }
        });

      },
      fun_load_user: function() {
        this.element_loading = true;

        console.log('查询日期=' + this.select_day);

        this.list_user = [];
        this.$post(
          api.http_method, Method_EasySelect('data_exp_rec_user', this.select_day, this.user_name)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;
            this.list_user = res.data.data;

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });

          }
        });
      },
      fun_sel_user: function(item) {
        console.log(item);
        this.dep_name = item.d_name;
        this.dep_user = item.u_name;
        this.dep_user_id = item.id;
        this.sheet_no = item.sheet_no;
        for (var i = 0; i < this.list_user.length; i++) {
          // console.log(this.list_user[i]);
          if (this.list_user[i].row_num == item.row_num) {
            document.getElementById('user_' + item.row_num).style.background = '#92a4f3';
          } else {
            if (this.list_user[i].row_num % 2 == 0) {
              document.getElementById('user_' + this.list_user[i].row_num).style.background = '#fff';
            } else {
              document.getElementById('user_' + this.list_user[i].row_num).style.background = '#f5f5f5';
            }
          }
        }
        this.fun_load_dep_user_all();
      },
      fun_load_dep_user_all: function() {

        this.list_dep_user_all = [];

        if (typeof(this.sheet_no) === 'undefined' || this.sheet_no == '') {
          this.$message({
            message: '没有匹配到考勤主单号,请检查模板配置和审核!',
            type: 'warning'
          });
          return;
        }
        this.element_loading = true;
        this.$post(
          api.http_method, Method_EasySelect('data_exp_rec_upass', this.sheet_no, this.dep_user_id)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;

            let first_day = t[0].work_date;
            // let y = '',
            //   m = '',
            //   d = '';
            // y = first_day.substring(0, 4);
            // m = first_day.substring(5, 7);
            // d = first_day.substring(8, 10);
            // console.log('年=' + y + ' 月=' + m + ' 日=' + d);
            // --"2021-02-26"
            let weekdate = new Date(first_day);
            let nweek = 0;
            nweek = weekdate.getDay();
            if (nweek == 0) {
              nweek = 7
            }

            let old_list = [];

            // console.log('第一天是星期' + nweek);
            for (let i = 1; i < nweek; i++) {
              let o = {};
              o.id = 'before_' + i;
              o.fixed = true;
              o.show = false;
              old_list.push(o);
            }

            for (let i = 0; i < t.length; i++) {
              let o = {};
              o.id = t[i].id;
              o.row_num = t[i].row_num;
              o.sheet_no = t[i].sheet_no;
              o.work_date = t[i].work_date;
              o.work_result = t[i].work_result;
              o.d_name = t[i].d_name;
              o.m_up_time = t[i].m_up_time;
              o.u_up_time = t[i].u_up_time;
              o.u_up_note = t[i].u_up_note;
              o.u_up_minu = t[i].u_up_minu;
              o.u_up_flag = t[i].u_up_flag;
			  
			  o.up_note = t[i].up_note;
			  o.down_note = t[i].down_note;


              // o.m_down_time = t[i].m_down_time;
              // o.a_up_time = t[i].a_up_time;
              o.a_down_time = t[i].a_down_time;
              o.u2_down_time = t[i].u2_down_time;
              o.u2_down_note = t[i].u2_down_note;
              o.u2_down_minu = t[i].u2_down_minu;
              o.u2_down_flag = t[i].u2_down_flag;

              o.result_flag = t[i].result_flag;
              o.result_ok = t[i].result_ok;

              if (t[i].f_up == '1') {
                o.f_up = true;
              } else {
                o.f_up = false;
              }

              // 打卡
              o.r_up_no = t[i].r_up_no;
              o.r_down_no = t[i].r_down_no;

              if (t[i].is_err == '1') {
                o.is_err = true;
              } else {
                o.is_err = false;
              }

              if ((Number(t[i].r_up_no) + Number(t[i].r_down_no)) > 0) {
                o.is_err = true;
                o.sel_radio = '2';
              } else {
                o.sel_radio = '1';
              }

              o.note = t[i].note;
              o.flag = t[i].flag;
              o.u_name = t[i].u_name;
              o.sys_date = t[i].sys_date;
              o.fixed = false;
              o.show = false;
              old_list.push(o);
            }

            for (let i = 1; i < 7; i++) {
              let o = {};
              o.id = 'after_' + i;
              o.fixed = true;
              o.show = false;
              old_list.push(o);
            }
            let week_arr = [];
            let num = 0;

            for (var i = 0; i < old_list.length; i++) {
              if (num == 7) {
                num = 0;
              }
              if (num < 7) {
                week_arr.push(old_list[i]);
              }
              if (num == 6) {
                this.list_dep_user_all.push(week_arr);
                week_arr = [];
              }
              num++;
            }


          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });

          }
        });
      },
      fun_list_sel: function(id, type) {
        // console.log('id='+id);
        // console.log('考勤状态',this.list_rec_class)
        if(type=='work'){
          this.sel_w_id = 0;
          this.sel_w_id = id;
          this.select_dep_user_day.work_result = this.list_rec_class[id - 1].val;

        }

        if(type=='result'){
          this.sel_c_id = 0;
          this.sel_c_id = id;
          this.select_dep_user_day.result_flag = this.list_rec_class[id - 1].val;


        }


      },
      fun_sel_dep_user_today: function(d) {
        // 选择单天的部门模板
        // console.log(d);
        this.select_day = d.work_date

        this.select_dep_user_day = {};
        this.select_dep_user_day = d;

        for (var i = 0; i < this.list_dep_user_all.length; i++) {
          for (var j = 0; j < this.list_dep_user_all[i].length; j++) {
            // console.log(this.data_tab[i]);
            if (this.list_dep_user_all[i][j].id == d.id) {
              document.getElementById('DU_' + d.id).style.background = '#92a4f3';
            } else {
              document.getElementById('DU_' + this.list_dep_user_all[i][j].id).style.background = '#fff';
            }
          }

        }

      },
      fun_sel_dep_user_day_toedit: function(d) {
        if (!d.fixed) {
          this.show_dep_user_day = true;
        }
      },
      fun_look_file: function() {
        this.show_file = true;

        this.element_loading = true;
        this.list_file = [];
        this.$post(
          api.http_method, Method_EasySelect('data_exp_rec_file', this.select_day, this.dep_user_id)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;
            for (let i = 0; i < t.length; i++) {
              let o = {};
              o.id = t[i].id;
              o.row_num = t[i].row_num;
              o.url = BackSpecial(t[i].f_url);
              o.sys_date = (t[i].sys_date).substring(0, 16);
              this.list_file.push(o);
            }

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });

          }
        });

      },
      fun_update_user: function(type) {
        if (typeof(this.select_dep_user_day) == 'undefined' || this.select_dep_user_day == '') {
          this.$message({
            message: '请选择要修改的数据',
            type: 'warning'
          });
          return;
        }

        if (typeof(this.dep_user_id) == 'undefined' || this.dep_user_id == 0) {
          this.$message({
            message: '请先选择人员信息!',
            type: 'warning'
          });
          return;
        }

        console.log(this.select_dep_user_day);
        let row_id = 0;
        let sys_date = '';
        let m_up = '',
          m_down = '';
        let a_up = '',
          a_down = '';
        let note = '';

        row_id = this.select_dep_user_day.id;
        sys_date = this.select_dep_user_day.sys_date;
        note = this.select_dep_user_day.note;

        // console.log('sheet_no' + '=[' + this.sheet_no + ']');
        // console.log('row_id' + '=[' + row_id + ']');
        // console.log('user_id' + '=[' + this.dep_user_id + ']');
        // console.log(this.select_dep_user_day.result_flag + '=[' + this.sel_c_id + ']');

        // return;

        let d = [];
        d.push(this.select_dep_user_day.sheet_no);
        d.push(this.dep_user_id);
        d.push(this.sel_c_id);
        d.push(m_up);
        d.push(m_down);
        d.push(a_up);
        d.push(a_down);
        d.push(note);
        d.push(this.select_dep_user_day.sel_radio);
        d.push(this.select_dep_user_day.work_result);

        this.element_loading = true;

        let r = (Math.random() + '').substring(0, 8);
        this.$post(
          api.http_method, Method_Common('data_kq_dep_user_mode_' + type, row_id, sys_date, d, r)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {

            this.$message({
              message: res.data.msg,
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });

          }

          this.fun_load_dep_user_all();

        });

      },
      refresh_data: function() {

      },
      fun_Excel_up: function() {
        let days = 0,
          month = 0;
        var d = new Date();
        days = daysFormMonth(this.select_day);


        if (typeof(this.select_day) == 'undefined' || this.select_day == '') {
          month = d.getMonth() + 1;
        } else {
          month = Number(this.select_day.substring(5, 7));
        }

        console.log(this.select_day + '对应月份' + month + '天数=' + days);

        this.parm_th = [];
        let o_user = {};
        o_user.name = '姓名';
        o_user.key = 'u_name';
        o_user.val = '';
        o_user.p = '1';
        o_user.type = 'text';
        this.parm_th.push(o_user);

        o_user = {};
        o_user.name = '开始日期';
        o_user.key = 's_date';
        o_user.val = '';
        o_user.p = '1';
        o_user.type = 'date';
        this.parm_th.push(o_user);

        o_user = {};
        o_user.name = '结束日期';
        o_user.key = 'e_date';
        o_user.val = '';
        o_user.p = '1';
        o_user.type = 'date';
        this.parm_th.push(o_user);

        for (let i = 0; i < days; i++) {
          let o = {};
          o.name = month + '月' + (i + 1) + '号';
          o.key = 'th' + (i + 1);
          o.val = '';
          o.p = '1';
          o.type = 'text';
          this.parm_th.push(o);
        }

        let o_all = {};
        o_all.name = '应出勤天数';
        o_all.key = 'day_all';
        o_all.val = '';
        o_all.p = '1';
        o_all.type = 'text';
        this.parm_th.push(o_all);

        // let  o_ok={};
        // o_ok.name='出勤天数';
        // o_ok.key='day_ok';
        // o_ok.val='';
        // o_ok.p='1';
        // o_ok.type='text';
        // this.parm_th.push(o_ok);

        // let  o_no={};
        // o_no.name='缺勤天数';
        // o_no.key='day_no';
        // o_no.val='';
        // o_no.p='1';
        // o_no.type='text';
        // this.parm_th.push(o_no);

        // let  o_r_ok={};
        // o_r_ok.name='应打卡次数';
        // o_r_ok.key='r_all';
        // o_r_ok.val='';
        // o_r_ok.p='1';
        // o_r_ok.type='text';
        // this.parm_th.push(o_r_ok);

        let r_count = {};
        r_count.name = '缺卡次数';
        r_count.key = 'r_no';
        r_count.val = '';
        r_count.p = '1';
        r_count.type = 'text';
        this.parm_th.push(r_count);

        let w_count = {};
        w_count.name = '缺日志次数';
        w_count.key = 'w_no';
        w_count.val = '';
        w_count.p = '1';
        w_count.type = 'text';
        this.parm_th.push(w_count);

        let o_note = {};
        o_note.name = '备注';
        o_note.key = 'note';
        o_note.val = '';
        o_note.p = '1';
        o_note.type = 'text';
        this.parm_th.push(o_note);

        this.excelup();


      },
      excelup: function() {
        var that = this;
        this.$nextTick(function() {
          that.$refs['excelup'].show_edit();
        });
      },



    }

  }
</script>

<style scoped="scoped">
  .my_push {
    padding: 10px;
  }

  .my_btn {
    display: inline-flex;
    vertical-align: sub;
    margin-left: 6px;
  }

  .my_btn>button {
    margin-left: 6px;
    margin-right: 6px;
  }

  .push-title {
    font-size: 20px;
    font-weight: 700;
    padding-bottom: 10px;
  }

  .push-table {
    max-height: 40vw;
    overflow: auto;
    padding-bottom: 10px;
    width: min-content;
  }

  .second-title {
    margin-top: 2px;
    padding: 2px 6px 2px 6px;
    min-width: 700px;
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #959595;
    margin: 1px;
  }


  .second-title>span {
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;

    min-width: 120px;

    font-size: 14px;
    font-weight: 700;
    text-align: center;
    height: 24px;
    line-height: 22px;
    border: 1px solid #959595;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
  }

  .second-row {
    margin-top: 1px;
    padding: 2px 6px 2px 6px;
    min-width: 700px;
    text-align: center;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    /* border: 1px solid #959595; */

  }

  .second-row>span {
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;

    min-width: 120px;

    font-size: 14px;
    font-weight: 700;
    text-align: center;

    height: 108px;
    border: 1px solid #959595;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    margin: 2px;
  }

  .second-item-row {
    text-align: left;
    padding: 2px 1px;
  }

  .second-item-row>.left {
    font-weight: 500;
    width: 32px;
    height: 28px;
    line-height: 28px;
  }

  .second-item-row>.right {
    font-weight: 500;
    width: calc(100% - 42px);
    height: 28px;
    line-height: 28px;
  }

  .second-item-row>.record {
    font-size: 12px;
    font-weight: 500;
    height: 20px;
    line-height: 20px;
    transform: scale(0.8);
    word-break: break-all;
  }



  .top_sheetno {
    position: fixed;
    top: 10px;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    /* opacity: 0.2; */
    /* border: 1px solid black; */
    /* padding-left: 20px; */
    /* padding-right: 20px; */
    border-radius: 5px;
    z-index: 3;
    width: 400px;
    text-align: center;
    padding: 20px;
    overflow-x: auto;
  }

  .content-tan {
    padding: 10px 6px;
  }

  .top_sheetno_close>img {
    width: 24px;
    height: auto;
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
  }

  .tan-row {
    margin-top: 2px;
    padding: 2px 6px 2px 6px;
    text-align: left;
    margin-left: 2%;
  }

  .tan-row>label {
    text-align: right;
    height: 20px;
    line-height: 20px;
    vertical-align: top;
  }

  .tan-row>span {
    font-weight: 500;
    width: calc(100% - 42px);
    height: 20px;
    line-height: 20px;
    vertical-align: top;
  }

  .tan-row>.my-file {
    cursor: pointer;

  }

  .tarn-row>button {
    text-align: right;
  }

  .third_pass {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .third-left {
    display: inline-block;
    width: 320px;
  }

  .third-right {
    display: inline-block;
    vertical-align: top;

  }

  .iserr {
    background-color: #ffff7f;
  }

  /* 第二个 弹窗  */
  .top_sheetfile {
    position: fixed;
    top: 20%;
    left: 60%;
    background-color: rgba(0, 0, 0, 0.5);
    /* opacity: 0.2; */
    /* border: 1px solid black; */
    /* padding-left: 20px; */
    /* padding-right: 20px; */
    border-radius: 5px;
    z-index: 4;
    width: 288px;
    text-align: center;
    padding: 20px;
    overflow-x: auto;
  }

  .content-tan {
    padding: 10px 6px;
  }

  .top_sheetfile_close>img {
    width: 24px;
    height: auto;
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
  }
</style>
